export default "__VITE_ASSET__qcmO1cP3__"